const Bar = {

  /**
   * @return {void}
   */
  initialize: function () {
    this.setup();
  },

  /**
   * Hides cart info bar when user scroll page
   * @return {void}
   */
  setup: () => {

    window.addEventListener('scroll', removeBar);

    function removeBar() {
      window.onscroll = null;
      window.removeEventListener('scroll', removeBar);

      let bar = document.querySelectorAll('.cart-info-bar');
      if (bar.length == 0) {
        return;
      }

      bar.forEach((div) => {

        div.classList.toggle('cart-info-bar__hide-bar');

        div.addEventListener("transitionend", hideBar);

        function hideBar() {
          div.style.display = 'none';
        }
      });
    }
  },
};

export default Bar;